export { default } from './Palette';
export * from './Palette.types';
